(() => {
  if (window.fkLivingInitialized) return;
  window.fkLivingInitialized = true;
  const initialize = (root = document) => {
    root.querySelectorAll('[data-fk-selector]').forEach(selector => {
      if (selector.dataset.initialized) return;
      selector.dataset.initialized = 'true';
      selector.querySelectorAll('[data-choice]').forEach(button => {
        button.addEventListener('click', () => {
          selector.querySelectorAll('[data-choice]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          selector.querySelectorAll('[data-choice-panel]').forEach(panel => panel.hidden = panel.dataset.choicePanel !== button.dataset.choice);
        });
      });
    });
    root.querySelectorAll('.fk-reviews').forEach(section => {
      const track = section.querySelector('[data-fk-reviews]');
      if (!track || track.dataset.initialized) return;
      track.dataset.initialized = 'true';
      const cards = [...track.children];
      const update = () => {
        let index = 0;
        let closest = Infinity;
        cards.forEach((card, i) => {
          const distance = Math.abs(card.getBoundingClientRect().left - track.getBoundingClientRect().left);
          if (distance < closest) { closest = distance; index = i; }
        });
        section.querySelector('[data-review-status]').textContent = `${index + 1} / ${cards.length}`;
        section.querySelector('[data-review-prev]').disabled = track.scrollLeft <= 1;
        section.querySelector('[data-review-next]').disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => {
        const step = cards[0].getBoundingClientRect().width + 18;
        track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      section.querySelector('[data-review-prev]').addEventListener('click', () => move(-1));
      section.querySelector('[data-review-next]').addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive: true});
      update();
    });

  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.fk-nav-drop[open],.fk-search[open],.fk-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
    if (event.target.closest('.fk-header-shell a')) {
      document.querySelectorAll('.fk-nav-drop[open],.fk-search[open],.fk-mobile-menu[open]').forEach(menu => menu.open = false);
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openMenus = [...document.querySelectorAll('.fk-nav-drop[open],.fk-search[open],.fk-mobile-menu[open]')];
    openMenus.forEach(menu => menu.open = false);
    openMenus[0]?.querySelector('summary')?.focus();
  });
})();

